import React from "react";

import EditIcon from "../images/edit-icon.svg";
import CloseIcon from "../images/remove-icon.svg"
import TrashIcon from "../images/mySendAPro/trash-icon.svg"
import "../css/favoriteWidgets.css"
import {
    ajax, loadMarketPlaceSet, 
    loadCarrierConfs, loadCarrierSets, ProfileLevels
} from '../components/globals';
import { Roles } from "../auth/rolesPermissions"
// import {
//     ajax, plainDate, LabelStatusColor, loadMarketPlaceSet, loadPickUpAddress,
//     loadCarrierConfs, loadCarrierSets, loadOrganizationCarrier, loadMarketPlaceOrders, downloadFile, downloadOrderLabels, myDeepCopy,
//     deleteOrders, deleteOrdersCreation, deleteAllOrdersCreation, showPopup,
//     getNavigation, getCreditWalletInfo
// } from '../components/globals';

/*import {
    InputBoxFlat, InputBox, InputColumn, InputSection, LogoListWide, MessageBox, ModalBox, ModalBoxFluid, UAdditionalService, UButton, UButtonFlat, UDate,
    UButtonGroup, UCardInfo, UCardTitle, UCheckbox, UCheckboxFlat, UInput, UInputFlat, UItemsList, ULabelFlat, URadioComplex, UTitle, UDescriptive, UGraphic
    , UserMessage, ULinkFlat, Link
} from '../components/utilities';*/
// import {
//     numberValidation, nameValidation, emailValidation, emptyValidation, isTrueValidation, zipValidation, phoneValidation,
//     validate
// } from '../components/validate';
// import { SingleOrderPackage } from '../components/ordercommon';
import { Languages } from '../components/languages';

import { Link } from 'react-router-dom';
import { PageTitle, ScrollableGrid, ScrollableGridItem, UserCard, UIGraphic, UISummary, UISummaryWidgetBar, UISummaryEmptyWidget, UISummaryWidget, UIPopup } from '../components/guiElements';
import { CreditBoxWidget } from '../components/creditBoxWidget';
import AddConfig from '../components/addConfig';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};



const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
//   padding: grid * 2,
//   margin: `0 ${grid}px 0 0`,

  // change background colour if dragging
//   background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle,
});

// const getListStyle = isDraggingOver => ({
//   background: isDraggingOver ? 'lightblue' : 'lightgrey',
//   display: "grid",
//   gridTemplateColumns: "repeat(5, 1fr)",
  
// });


export class MySendaPro extends React.Component {
    constructor(props) {
        super(props);
        this.le = Languages.getSection('MySendaPro');
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));

        this.addUser = this.addUser.bind(this);
        this.goToUserProfile = this.goToUserProfile.bind(this);
        this.showFavoriteWidgetsModal = this.showFavoriteWidgetsModal.bind(this);
        this.closeFavoriteWidgetsModal = this.closeFavoriteWidgetsModal.bind(this);
        this.widgetSelectedHandler = this.widgetSelectedHandler.bind(this);

        this.onDragEnd = this.onDragEnd.bind(this);

        this.leUserProfile = Languages.UserProfile[Languages.selectedLanguage];

        this.state = {
            output: '',
            totals: {
                todayCustomer: 0, totCustomers: 0, todayStocked: 0, totStocked: 0, todayNationalOrders: 0,
                totNationalOrders: 0, todayInternationalOrders: 0, totInternationalOrders: 0
            },
            graphData: [],
            card: {
                title: this.leUserProfile.card.title,
                image: this.uc.image || '../../images/user3x-d.png',
                name: this.uc.firstName + " " + this.uc.lastName,
                email: this.uc.username,
                level: this.uc.userRole.toUpperCase(),
                logout: this.leUserProfile.card.logout,
                edit: this.leUserProfile.card.edit,
                addUser: this.leUserProfile.addUser
            },
            marketPlaceListConf: [],
            courierListConf: [],
            creditInfo: null,
            myFavoriteWidgets: [],
            allFavoriteWidgets: [],
            modalTarget: "",
        };
    }
    addUser() {

        this.props.navigateTo("SET_PROFILE", "NEW_USER");

    }
    goToUserProfile() {

        this.props.navigateTo("SET_PROFILE", "");

    }
    componentDidMount() {

        if (this.uc.userRole == Roles.READONLY) 
            return;

        //this.props.loaderShow(0);
        ajax(this,
            {
                method: 'get',
                url: '/api/dashboard/home-dashboard',
                headers: { Authorization: 'Bearer ' + this.uc.jwtToken }
            },
            response => {
                let graphicData = response.data.result.lastWeekOrders;
                let totals = response.data.result.totals;
                let allFavoriteWidgets = response.data.result.allFavoriteWidgets
                let myFavoriteWidgets = response.data.result.myFavoriteWidgets

                this.setState({
                    graphData: graphicData,
                    totals: totals,
                    allFavoriteWidgets,
                    myFavoriteWidgets,
                });
                //this.props.componentDidMount();
            },
            error => {
                //this.props.componentDidMount();
            }
        );

        loadMarketPlaceSet(this.uc.jwtToken,
            listOfMarketPlaces => {
                let marketPlaceListConf = listOfMarketPlaces.filter((el) => (el.status)).map((el) => ({
                    id: el.marketplace, name: el.name, logo: el.logo
                }));

                this.setState({
                    marketPlaceListConf: marketPlaceListConf
                });
            },
            () => { },
            this
        );

        loadCarrierConfs(this.uc.jwtToken,
            carrierConf => {
                loadCarrierSets(this.uc.jwtToken,
                    carrierSet => {
                        carrierSet.forEach(s => {
                            let id = s.carrierId;
                            carrierConf.forEach(c => {
                                if (c.id == s.carrierId)
                                    s.logo = c.logo;
                            });
                        });

                        this.setState({
                            courierListConf: carrierSet
                        });
                    },
                    error => { },
                    this);
            },
            error => { },
            this
        );
    }

    scrollMarketplace(ev, direction) {
        if (this.state.marketPlaceListConf.length > 1) {
            let list = this.state.marketPlaceListConf;
            if (direction < 0) {
                //left
                list.unshift(list[list.length - 1]);
                list = list.splice(0, list.length - 1)
            }
            else if (direction > 0) {
                //right
                list.push(list[0]);
                list = list.splice(1);
            }
            this.setState({ marketPlaceListConf: list });
        }
    }

    scrollCourier(ev, direction) {
        if (this.state.courierListConf.length > 1) {
            let list = this.state.courierListConf;
            if (direction < 0) {
                //left
                list.unshift(list[list.length - 1]);
                list = list.splice(0, list.length - 1)
            }
            else if (direction > 0) {
                //right
                list.push(list[0]);
                list = list.splice(1);
            }
            this.setState({ courierListConf: list });
        }
    }

    widgetSelectedHandler(item) {
        this.props.loaderShow(0);
        ajax(this,
            {
                method: 'post',
                url: `api/dashboard/add-widget?id=${item.id}`,
                headers: { Authorization: 'Bearer ' + this.uc.jwtToken }
            },
            () => {
                const newMyfavoriteWidgetItems = [...this.state.myFavoriteWidgets];
                newMyfavoriteWidgetItems.push(item);
                
                this.setState((prevState) => {
                    const currentWidgetIndex = prevState.allFavoriteWidgets.findIndex(widget => widget.id === item.id);
                    const updatedWidget = Object.assign({}, prevState.allFavoriteWidgets[currentWidgetIndex]);
                    updatedWidget.isSelected = true;
                    const allFavoriteWidgetsUpdated = prevState.allFavoriteWidgets.slice();
                    allFavoriteWidgetsUpdated[currentWidgetIndex] = updatedWidget;
                    return {
                        modalTarget: "",
                        myFavoriteWidgets: newMyfavoriteWidgetItems,
                        allFavoriteWidgets : allFavoriteWidgetsUpdated
                    }
                });
                this.props.loaderHide();
            },
            error => {
                this.props.loaderHide();
            }
        );
    }

    updateFavoriteWidget(item) {
        const newMyfavoriteWidgetItems = [...this.state.myFavoriteWidgets];
        this.setState((prevState) => {
            const currentWidgetIndex = prevState.allFavoriteWidgets.findIndex(widget => widget.id === item.id);
            const updatedWidget = Object.assign({}, prevState.allFavoriteWidgets[currentWidgetIndex]);
            updatedWidget.isSelected = true;
            const allFavoriteWidgetsUpdated = prevState.allFavoriteWidgets.slice();
            allFavoriteWidgetsUpdated[currentWidgetIndex] = updatedWidget;
            return {
                modalTarget: "",
                myFavoriteWidgets: newMyfavoriteWidgetItems,
                allFavoriteWidgets : allFavoriteWidgetsUpdated
            }
        });
    }

    showFavoriteWidgetsModal(modalTarget) {
        this.setState({
            modalTarget
        });
    }

    closeFavoriteWidgetsModal() {
        this.setState({
            modalTarget: ''
        });
    }


    removeFavoriteWidget(item) {
        this.props.loaderShow(0);
        ajax(this,
            {
                method: 'post',
                url: `api/dashboard/delete-widget?id=${item.id}`,
                headers: { Authorization: 'Bearer ' + this.uc.jwtToken }
            },
            () => {
                const newMyfavoriteWidgetItems = [...this.state.myFavoriteWidgets];
                this.setState((prevState) => {
                    const currentWidgetIndex = prevState.myFavoriteWidgets.findIndex(widget => widget.id === item.id);
                    newMyfavoriteWidgetItems.splice(currentWidgetIndex, 1);
                    const currentAllFavoriteWidgetIndex = prevState.allFavoriteWidgets.findIndex(widget => widget.id === item.id);
                    const updatedAllFavoriteWidget = Object.assign({}, prevState.allFavoriteWidgets[currentAllFavoriteWidgetIndex]);
                    updatedAllFavoriteWidget.isSelected = false;
                    const allFavoriteWidgetsUpdated = prevState.allFavoriteWidgets.slice();
                    allFavoriteWidgetsUpdated[currentAllFavoriteWidgetIndex] = updatedAllFavoriteWidget;

                    return {
                        myFavoriteWidgets: newMyfavoriteWidgetItems,
                        allFavoriteWidgets : allFavoriteWidgetsUpdated
                    }
                });
                this.props.loaderHide();
            },
            error => {
                this.props.loaderHide();
            }
        );
    }


    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
          return;
        }

        
        const myFavoriteWidgets = reorder(
            this.state.myFavoriteWidgets,
            result.source.index,
            result.destination.index
        );
        const myFavoriteIdWidgets = myFavoriteWidgets.map((widget) => {
            return {
                id: widget.id
            }
        })

        this.props.loaderShow(0);
        ajax(this,
            {
                method: 'post',
                url: 'api/dashboard/update-widgets',
                headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                data: myFavoriteIdWidgets
            },
            () => {
                
                this.props.loaderHide();
            },
            error => {
                this.props.loaderHide();
            }
        );
        this.setState({
            myFavoriteWidgets,
          });
    }
  

    render() {

        /*let months = [];
        let data = [];
        this.state.graphData.forEach((el) => {
            let month = le.r1.months[el.month];
            months.push(<div>{month}</div>);
            data.push(el.val);
        });
        let maxAbs = Math.max.apply(null, data);
        let inter = Math.floor(maxAbs / 4 + 1) | 1;

        let graphRows = [];
        for (let i = 4; i >= 0; i--) {
            graphRows.push(<div key={"div" + i} className="graph-row">{i * inter}</div>);
        }
        graphRows.push(<div className="bottom-row">{months}</div>);*/

        const isWarehouseAdmin = this.uc.userRole === Roles.WAREHOUSEADMIN;
        const isWarehouseUser = this.uc.userRole === Roles.WAREHOUSEUSER;

        if (this.uc.userRole != Roles.READONLY) {
            let data = this.state.graphData.map((el) => ({ name: this.le.r1.months[el.month], value: el.val }));

            let mpicons = this.state.marketPlaceListConf.map(
                (el, idx) => (<ScrollableGridItem key={idx} id={el.id} icon={el.logo} title={el.name} />)
            );

            let cicons = this.state.courierListConf.map(
                (el, idx) => (<ScrollableGridItem key={idx} id={el.id} icon={el.logo} title={el.name} />)
            );

            let credits = <CreditBoxWidget navigateTo={this.props.navigateTo} />;

        const allFavoriteWidgets = this.state.allFavoriteWidgets.map((featureItem, featureSectionIndex) => {
            const widgetClasses = ["widget", featureItem.isSelected ? "widget-disabled": ""].join(" ")
            return  (
                <div key={featureSectionIndex} className={widgetClasses} onClick={() => this.widgetSelectedHandler(featureItem)}>
                    <div className="widget-content feature-section card-box cursor-pointer">
                        <div className="feature-section-setings">
                            <div className="feature-item-title-container">
                                <img src={featureItem.icon} />
                                <div className="feature-item-title">{featureItem.title}</div>
                            </div>
                            <div className="button-container">
                                {featureItem.downloadCSV.trim().length > 0 && <div className="button btn-solid">{featureItem.downloadCSV}</div>}

                                {featureItem.total.value > 0 && 
                                <div className="total">
                                    <p className="total-before">{featureItem.total.text}</p>
                                    <p className="total-value">{featureItem.total.value}{featureItem.total.todayValue > 0 && <span className="total-today">(+{featureItem.total.todayValue})</span>}</p>
                                    
                                </div>}
                                {featureItem.linkText.trim().length > 0 && featureItem.linkText.trim().length>0 && featureItem.linkTo.map((link, index) => <div key={index} to={link} className="button">{featureItem.linkText}</div>)}

                                {featureItem.createOrder.text.trim().length > 0 && <div to={featureItem.createOrder.linkTo} className="button btn-solid">{featureItem.createOrder.text}</div>}
                                {featureItem.createSingleOrder.text.trim().length > 0 && <div to={featureItem.createSingleOrder.linkTo} className="button">{featureItem.createSingleOrder.text}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }, this);



        let popup = null;
        if (this.state.modalTarget == 'addFavoriteWidgets') {
            popup = <UIPopup
                className="favorite-widget-popup"
                title={this.le.favoriteWidgets.popupTitle}
                onCancel={this.closeFavoriteWidgetsModal}>
                
                {allFavoriteWidgets}
            </UIPopup>;
            }

        return <div className="page-mysendapro">
            <PageTitle icon="../images/mainMenu/MySendapro.png" title={Languages.getSection('Main').menuLabels.mySendapro} hideFaq={true}>
                {!isWarehouseAdmin && !isWarehouseUser && credits}
            </PageTitle>
            <div className="page-content">
                <div className="first-row">
                    <UserCard handlers={{ onEdit: this.goToUserProfile }} data={this.state.card} logoutClick={this.props.logoutClick} />
                    {!isWarehouseAdmin && !isWarehouseUser && (<UIGraphic title={this.le.r1.title} data={data} />)}
                </div>
                {!isWarehouseAdmin && !isWarehouseUser && (
                    <>
                     <div className="favorite-features-container">
                        <div className="panel-title">{this.le.favoriteWidgets.title}</div>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <div className="favorite-features-list-container page-content">
                        
                                <Droppable droppableId="droppable" direction="horizontal" >
                                    {(provided, snapshot) => (
                                        <div 
                                                ref={provided.innerRef}
                                                // style={getListStyle(snapshot.isDraggingOver)}
                                                {...provided.droppableProps}
                                            >
                                            {this.state.myFavoriteWidgets.map((featureItem, featureSectionIndex) => (
                                                <Draggable key={featureItem.id} draggableId={featureItem.id.toString()} index={featureSectionIndex}>
                                                {(provided, snapshot) => (
                                                    <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                    >
                                                        <div key={featureSectionIndex} className="widget">
                                                            <div className="widget-content feature-section card-box">
                                                                <div className="feature-section-setings">

                                                                    <div className="feature-item-title-container">
                                                                        <div className="feature-item-icon"><img src={featureItem.icon} /></div>
                                                                        <div className="feature-item-title">{featureItem.title}</div>
                                                                        <div className="feature-item-more-options">
                                                                            <img src={TrashIcon} onClick={() => this.removeFavoriteWidget(featureItem)}/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="button-container">
                                                                        {featureItem.downloadCSV.trim().length > 0 && <div className="button btn-solid">{featureItem.downloadCSV}</div>}

                                                                        {featureItem.total.value > 0 && 
                                                                        <div className="total">
                                                                            <p className="total-before">{featureItem.total.text}</p>
                                                                            <p className="total-value">
                                                                                {featureItem.total.value}
                                                                                {featureItem.total.todayValue > 0 && <span className="total-today">(+{featureItem.total.todayValue})</span>}
                                                                                
                                                                            </p>
                                                                        </div>}
                                                                        {featureItem.linkText.trim().length > 0 && featureItem.linkText.trim().length>0 && featureItem.linkTo.map((link, index) => <div onClick={() => {this.props.navigateTo(link)}} key={index} className="button">{featureItem.linkText}</div>)}

                                                                        {featureItem.createOrder.text.trim().length > 0 && <div onClick={() => {this.props.navigateTo("ORDERS")}}  className="button btn-solid">{featureItem.createOrder.text}</div>}
                                                                        {featureItem.createSingleOrder.text.trim().length > 0 && <div onClick={() => {this.props.navigateTo("SINGLE-ORDERS")}}  className="button">{featureItem.createSingleOrder.text}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                </Draggable>
                                            ))}

                                            {provided.placeholder}
                                            {this.state.myFavoriteWidgets.length < 5 && <AddConfig onClick={this.showFavoriteWidgetsModal.bind(this, 'addFavoriteWidgets')} className="add-favorite-feature" />}
                                        </div>
                                    )}
                                </Droppable>
                                 { popup }
                            </div>
                        </DragDropContext>
                    </div>
          
                <div className="connection-panel">
                    <div key="p1" className="marketplace-panel">
                        <div className="panel-title">{this.le.r2.caption6}</div>
                        <div className="marketplace-container">
                            <ScrollableGrid>
                                {mpicons}
                            </ScrollableGrid>
                            <div className="scroll-panel" >
                                <div className={"arrow-right " + (mpicons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollMarketplace(ev, +1))} />
                                <div className={"arrow-left " + (mpicons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollMarketplace(ev, -1))} />
                            </div>
                        </div>
                    </div>

                    <div key="p2" className="marketplace-panel">
                        <div className="panel-title">{this.le.r2.caption7}</div>
                        <div className="marketplace-container">
                            <ScrollableGrid>
                                {cicons}
                            </ScrollableGrid>
                            <div className="scroll-panel">
                                <div className={"arrow-right " + (cicons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollCourier(ev, +1))} />
                                <div className={"arrow-left " + (cicons.length > 1 ? '' : 'disabled')} onClick={(ev) => (this.scrollCourier(ev, -1))} />
                            </div>
                        </div>
                    </div>
                </div>
                </>
                )}
                </div>
            </div>;
        }
        else {
            return <div className="page-mysendapro">
                <PageTitle icon="../images/mainMenu/MySendapro.png" title={Languages.getSection('Main').menuLabels.mySendapro} hideFaq={true}>
                    
                </PageTitle>
                <div className="page-content">
                    <div className="first-row">
                        <UserCard handlers={{ onEdit: this.goToUserProfile }} data={this.state.card} logoutClick={this.props.logoutClick} />
                        
                    </div>

                    

                </div>
            </div>;
        }

        /*
            <div className="row">
                <div className="col-3 order-user-card">
                    <UserCard handlers={{ onEdit: this.goToUserProfile, onAddUser: this.uc.userRole == 'admin' ? this.addUser : null }} data={this.state.card} logoutClick={this.props.logoutClick} />
                    {/ *(this.uc.userRole=="admin") ? (
                                <Fragment>
                                    <div style={{ marginTop: "2rem" }} />
                                    <ULink name="addUser" textClass="bold" text={"+ " + this.leUserProfile.addUser} onClick={this.addUser} />
                                </Fragment>) : ""* /}

                </div>
                <div className="col">
                    <div className="row ucard graph">
                        <div className="col px-3 pt-3">
                            <UGraphic canvasStyle={{ top: "6rem", left: "3.3rem", width: "95%", height: "60%" }} maxAbs={inter * 4} data={data} />
                            <UCardTitle text={le.r1.title} />
                            {legY}
                            <div className="row">
                                {months}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row deep-h6">
                <div className="col info-box mango">
                    <h4>{this.state.totals.totCustomers} {le.r2.caption1}</h4>
                    <h6>{this.state.totals.todayCustomers} {le.r2.today}</h6>
                </div>
                <div className="col info-box mango">
                    <h4>{this.state.totals.totStocked} {le.r2.caption2}</h4>
                    <h6>{this.state.totals.todayStocked} {le.r2.today}</h6>
                </div>
                <div className="col info-box marine-blue">
                    <h4>{this.state.totals.totNationalOrders} {le.r2.caption3}</h4>
                    <h6>{this.state.totals.todayNationalOrders} {le.r2.today}</h6>
                </div>
                <div className="col info-box marine-blue">
                    <h4>{this.state.totals.totInternationalOrders} {le.r2.caption4}</h4>
                    <h6>{this.state.totals.todayInternationalOrders} {le.r2.today}</h6>
                </div>
            </div>

        </div>;*/
    }
}

